export default {
	CONFIRM_DELETE: 'Yes, delete!',
	MODAL_HEADER: 'Are you sure?',
};
